import React from 'react';
import { getDisplayValue } from '../configs/fieldRenderers';

const ResumeInfoGrid = ({ fields = [], data = {}, emptyText }) => {
  if (emptyText && fields.length === 1 && !data[fields[0].props]) {
    return <div className="resume-new-empty">{emptyText}</div>;
  }

  return (
    <div className="resume-new-info-grid">
      {fields.map((field) => (
        <div className="resume-new-info-item" key={`${field.label}-${field.props}`}>
          <label>{field.label}：</label>
          <span>{getDisplayValue(field, data)}</span>
        </div>
      ))}
    </div>
  );
};

export default ResumeInfoGrid;
